import { render, staticRenderFns } from "./close-icon.vue?vue&type=template&id=29c382af&functional=true&"
import script from "./close-icon.vue?vue&type=script&lang=ts&"
export * from "./close-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports